import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';


@Component({
  selector: 'app-discussion-market-share-preview',
  templateUrl: './discussion-market-share-preview.component.html',
  styleUrls: ['./discussion-market-share-preview.component.scss']
})
export class DiscussionMarketSharePreview implements OnInit {
  // @HostListener('document:click', ['$event'])
  // onClick(event: MouseEvent) {
  //   const targetElement = event.target as HTMLElement;
  //   const ckeditorElement = this.elementRef.nativeElement.querySelector('ckeditor');
    
  //   if (!ckeditorElement.contains(targetElement)) {
  //     // Xử lý logic khi chuột được nhấp chuột ra khỏi vùng CKEditor
  //     console.log("Chuột đã nhấp chuột ra khỏi CKEditor");
  //   }
  // }
  @Input() dataReport: any
  title_report = 'Báo cáo thị phần thảo luận các thương hiệu';
  //barchart
  public barChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom'
    },

    // We use these empty structures as placeholders for dynamic theming.
    plugins: {
      //exportEnabled: 1,
      labels: {
        render: 'value',
        fontColor: 'black',
        position: 'outside',
        precision: 1,
        arc: true,
        fontSize: 12,
        textMargin: 0,
        fontStyle: 'bold',
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
      tooltip: '1',
    }
  };
  public barChartLabels: any[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartColors: Color[] = [
    { backgroundColor: ["#0082bf", "#abe4ff"] },
    { backgroundColor: ["#0082bf", "#abe4ff"] }
  ];

  public barChartData = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
  ];

  public doughnutChartOptions: any = {
    responsive: true,
    plugins: {
      labels: {
        display: false
      }
    },
    legend: {
      display: false
    }
  }
  public doughnutChartType = 'doughnut';
  public doughnutChart = {
    filter: {
      doughnutChartLabels: [],
      doughnutChartData: [
      ],
      name: "",
      total: 0
    },
    lastFilter: {
      doughnutChartLabels: [],
      doughnutChartData: [
      ],
      name: "",
      total: 0
    }
  }

  public doughnutChartColors: Color[] = [
    { backgroundColor: ["#6998F3", "#FF6262","#4EBD74","#FFC107"] }
  ];

  htmlTop = '';

  getTotal(): number {
    return this.doughnutChart.filter.doughnutChartData.reduce((a, b) => a + b, 0);
  }
  

  getPercentage(number: number): string {
    const total = this.getTotal();
    const percentage = (number / total) * 100;
    return percentage.toFixed(2) + '%';
  }

  getTotal2(): number {
    return this.doughnutChart.lastFilter.doughnutChartData.reduce((a, b) => a + b, 0);

  }
  

  getPercentage2(number: number): string {
    const total = this.getTotal2();
    const percentage = (number / total) * 100;
    return percentage.toFixed(2) + '%';
  }
  ckeditorContent = '';

  constructor() {

  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {

    this.mappingData()
    // changes.prop contains the old and the new value...
  }
  mappingData() {
    if (this.dataReport && this.dataReport.data) {
      if (this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      //let colorGeneral = this.dataReport.data.colorGeneral;
      //dataReportFilter
      this.doughnutChart.lastFilter.total = this.dataReport.data.dataLastReportFilter.total;
      this.doughnutChart.lastFilter.name = this.dataReport.data.dataLastReportFilter.name;
      let dataLastFilter = this.dataReport.data.dataLastReportFilter.data;
      this.doughnutChart.lastFilter.doughnutChartLabels = [];
      this.doughnutChart.lastFilter.doughnutChartData = [];
      for (const name in dataLastFilter) {
        this.doughnutChart.lastFilter.doughnutChartLabels.push(name);
        this.doughnutChart.lastFilter.doughnutChartData.push(dataLastFilter[name]);
      }

      //dataLastReportFilter

      this.doughnutChart.filter.total = this.dataReport.data.dataReportFilter.total;
      this.doughnutChart.filter.name = this.dataReport.data.dataReportFilter.name;
      let dataFilter = this.dataReport.data.dataReportFilter.data;
      this.doughnutChart.filter.doughnutChartLabels = [];
      this.doughnutChart.filter.doughnutChartData = [];
      for (const name in dataFilter) {
        this.doughnutChart.filter.doughnutChartLabels.push(name);
        this.doughnutChart.filter.doughnutChartData.push(dataFilter[name]);
      }
      if(this.dataReport.data.dataReportFilter1 && this.dataReport.data.dataLastReportFilter1) {
        let dataFilter1 = this.dataReport.data.dataReportFilter1;
        let dataLastFilter1 = this.dataReport.data.dataLastReportFilter1;
    
        this.barChartLabels = Object.keys(dataFilter1.data);
        this.barChartData[0].data = Object.keys(dataLastFilter1.data).map(c => dataLastFilter1.data[c]);
        this.barChartData[0].label = dataLastFilter1.name;
        this.barChartData[1].data = Object.keys(dataFilter1.data).map(c => dataFilter1.data[c]);
        this.barChartData[1].label = dataFilter1.name;
    
        let dataKeys = Object.keys(dataFilter1.data);
        this.barChartColors[0].backgroundColor = dataKeys.map(() => "#abe4ff");
        this.barChartColors[1].backgroundColor = dataKeys.map(() => "#0082bf");
      }
     


      this.htmlTop = this.dataReport.data.htmlTop;

    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/discussion-market-share-preview/discussion-market-share-preview.component.ts